var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongjinOH
 * @contact hjoh@detech.co.kr
 * @date 2023-04-20
 * @brief SEI 진단점검하기 컴포넌트
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
// recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { alertState, checkTypeState } from "../../../../../recoil/assessmentState";
import { reLoadState, userInfoLoginState } from "../../../../../recoil/userState";
// utils
import * as HTTPUTIL from "../../../../../utils/api/HttpUtil";
import * as CUTIL from "../../../../../utils/commUtils";
import * as CONST from "../../../../../utils/Const";
// datepicker
import dayjs from "dayjs";
import DatePicker from "react-datepicker";
// datepicker 디자인 - 없으면 깨짐
import "react-datepicker/dist/react-datepicker.css";
// datepocker 언어
import { enUS, ko } from "date-fns/esm/locale";
import { langId, langState } from "../../../../../recoil/langState";
import { loadingBoxState } from "../../../../../recoil/menuState";
import { useTrans } from "../../../../../utils/langs/useTrans";
import ConfirmPop from "../../../../common/popup/ConfirmPop";
function CheckLast(props) {
    const t = useTrans();
    const langs = useRecoilValue(langState);
    // recoil
    const [check, setCheck] = useRecoilState(checkTypeState);
    const userInfo = useRecoilValue(userInfoLoginState);
    const [reload, setReload] = useRecoilState(reLoadState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [alert, setAlert] = useRecoilState(alertState);
    const langIds = useRecoilValue(langId);
    // props
    const { handleOpenPop, checkItem } = props;
    // Mobile Check용
    const [isMobile, setMobile] = useState(false);
    // width 1650 Check용
    const [is1650M, setIs1650M] = useState(false);
    useEffect(() => {
        // resize handler
        // Mobile 체크
        function handleResize() {
            if (window.innerWidth <= 1650) {
                setIs1650M(true);
            }
            else {
                setIs1650M(false);
            }
            if (window.innerWidth <= 940) {
                setMobile(true);
            }
            else {
                setMobile(false);
            }
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    });
    // isMobile 여부 랜더링 후 확인
    useDebounceEffect(() => __awaiter(this, void 0, void 0, function* () {
        if (window.innerWidth <= 940) {
            setMobile(true);
        }
        if (window.innerWidth <= 1650) {
            setIs1650M(true);
        }
    }), 100);
    const [errorList, setErrorList] = useState([]);
    const tabData = [
        { name: t("라벨.사진첨부"), id: 1 },
        { name: t("라벨.다음점검일설정"), id: 2 },
    ];
    const [tabNum, setTabNum] = useState(tabData[0].id);
    const [potoName, setPotoName] = useState("");
    const [totalComment, setTotalComment] = useState("");
    const [file, setFile] = useState([]);
    const [uploadFiles, setUploadFiles] = useState([]);
    const [imageInfo, setImageInfo] = useState(null);
    const [groupName, setGroupName] = useState("");
    const lastNum = 10;
    t("라벨.T_월", ["1"]);
    const [today, setToday] = useState(null);
    const automaticCheckCycle = [
        { cycleNo: t("라벨.없음"), value: 0 },
        { cycleNo: t("라벨.T_일", ["30"]), value: 30 },
        { cycleNo: t("라벨.T_일", ["60"]), value: 60 },
        { cycleNo: t("라벨.T_일", ["90"]), value: 90 },
        { cycleNo: t("라벨.T_일", ["180"]), value: 180 },
        { cycleNo: t("라벨.T_일", ["365"]), value: 365 },
    ];
    const [schduleAdd, setSchduleAdd] = useState({
        isOutSource: false,
        period: automaticCheckCycle[0].value,
    });
    const [url, setUrl] = useState(null);
    useEffect(() => {
        // 이미지 수정
        handleOpenPop("pop-edit-image", _jsx(ImageEditPop, { imageInfo: imageInfo, groupName: groupName, setGroupName: setGroupName, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: t("라벨.사진제목") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => ClosePop("pop-edit-image") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        // 이미지 삭제
        handleOpenPop("pop-delete-image", _jsx(ImageDeletePop, { imageInfo: imageInfo }));
        handleOpenPop("pop-img", _jsx(ImagePop, { url: url, htmlClose: _jsx(_Fragment, { children: _jsx("h1", { children: groupName }) }) }));
        handleOpenPop("pop-confirm", _jsx(ConfirmPop, { type: "check", clickfn: totalCommentClick, profn: persent }));
    }, []);
    function ClosePop(id) {
        CUTIL.jsclose_Popup(id);
    }
    let appPath = `?assessmentId=${check.assessmentId}`;
    // 진단점검 API
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/assessment${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + reload + langIds,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setTotalComment(data.body.totalComment ? data.body.totalComment : totalComment);
                setUploadFiles(data.body.image);
                setToday(check.schdeulerId > 0 && check.period > 0 ? new Date(check.dueDate) : null);
            }
        }
    }, [data, langIds]);
    // 탭 이동
    function TabClick(e, item) {
        setTabNum(item.id);
    }
    // 첨부파일 저장
    function saveFileImage(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const files = e.target.files;
            let imageUpload = [...file];
            for (let i = 0; i < files.length; i++) {
                //  미리보기 구현시 필요 URL.createObjectURL(file[i]);
                imageUpload.push(files[i]);
            }
            if (imageUpload.length > lastNum) {
                imageUpload = imageUpload.slice(0, 10);
                setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "첨부파일은 10개 까지 가능합니다." }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            }
            setFile(imageUpload);
            e.target.value = ""; // file name 초기화
        });
    }
    // 이미지 삭제
    function onClickAttachFileDelete(index) {
        setFile(file.filter((_, idx) => idx !== index));
    }
    // 첨부파일 업로드
    function uploadFileImage(e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!potoName) {
                setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.사진제목입력") }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            }
            else {
                if (file.length + uploadFiles.length <= lastNum) {
                    const formData = new FormData();
                    // 파일 데이터 저장
                    file.map((files) => formData.append("files", files));
                    let data = null;
                    data = yield HTTPUTIL.PromiseHttp({
                        httpMethod: "POSTF",
                        appPath: `/images/assessment?assessmentId=${check.assessmentId}&groupName=${potoName}`,
                        appQuery: formData,
                        userToken: userInfo.loginInfo.token,
                    });
                    if (data) {
                        if (data.codeNum == CONST.API_200) {
                            setRecoilIsLoadingBox(true);
                            setReload(true);
                            setPotoName("");
                            setFile([]);
                            setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.body }));
                            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                            setReload(false);
                            setRecoilIsLoadingBox(false);
                        }
                        else {
                            // need error handle
                            if (data.errorList) {
                                setErrorList(data.errorList);
                                setRecoilIsLoadingBox(false);
                            }
                            else {
                                setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : t("라벨.사진첨부하세요") }));
                                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                                setRecoilIsLoadingBox(false);
                            }
                        }
                    }
                }
                else {
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "첨부파일은 10개 까지 가능합니다." }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    // 삭제 ,수정, 이미지 팝업
    function ImageInfo(e, item) {
        setGroupName(item.groupName);
        setImageInfo(item);
        setUrl(item.url);
        CUTIL.jsopen_Popup(e);
    }
    // 자동 점검주기
    function automaticCheckCycleClick(acc) {
        setSchduleAdd(Object.assign(Object.assign({}, schduleAdd), { period: acc.value }));
    }
    // 점검 예약 등록
    function SchdeulerAdd(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/schedule`,
                appQuery: {
                    dueDate: dayjs(today).format("YYYYMMDD").toString(),
                    itemId: check.itemInfo.id,
                    checkVersionId: check.chekVersionTypeInfo.checkVersionId,
                    isOutSource: !schduleAdd.isOutSource,
                    period: schduleAdd.period,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    setCheck(Object.assign(Object.assign({}, check), { schdeulerId: data.body.scheduleId, period: data.body.period, dueDate: data.body.dueDate }));
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.다음점검일이설정되었습니다") }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
                else {
                    // need error handle
                    setErrorList(data.errorList);
                }
            }
            setReload(false);
        });
    }
    // 점검 예약 수정 완료
    function SchdeulerEdit(item) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/schedule/${check.schdeulerId}`,
                appQuery: {
                    dueDate: dayjs(today).format("YYYYMMDD").toString(),
                    checkVersionId: item.checkVersionId,
                    isOutSource: true,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    setCheck(Object.assign(Object.assign({}, check), { schdeulerId: data.body.scheduleId, period: data.body.period, dueDate: data.body.dueDate }));
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.점검일이수정되었습니다") }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReload(false);
                }
                else {
                    // need error handle
                    if (data.errorList) {
                        setErrorList(data.errorList);
                    }
                    else {
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: CONST.ERROR_MSG }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }
        });
    }
    function totalCommentPop(e) {
        CUTIL.jsopen_Popup(e);
    }
    //결과 확인
    function totalCommentClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/assessment/${check.assessmentId}`,
                appQuery: {
                    totalComment: totalComment ? totalComment : null,
                    isTempSave: false,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    setCheck(Object.assign(Object.assign({}, check), { nextStep: "result", totalComment: data.body.totalComment, assessmentInfo: {
                            isTempSave: false,
                            reportId: check.assessmentInfo.reportId,
                        } }));
                    setReload(false);
                }
                else {
                    // need error handle
                    if (data.errorList) {
                    }
                    else
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: CONST.ERROR_MSG }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    // 종합의견 이전 이벤트
    function totalCommentPreClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/assessment/${check.assessmentId}`,
                appQuery: {
                    totalComment: totalComment,
                    isTempSave: true,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    let checkitemId = null;
                    checkItem.filter((ckf) => ckf.itemNum == check.endpage).map((ckf) => (checkitemId = ckf.checkitemId));
                    setCheck(Object.assign(Object.assign({}, check), { checkitemId: checkitemId, itemNum: check.endpage, preCheckitemId: -1, totalComment: data.body.totalComment, assessmentInfo: {
                            isTempSave: true,
                            reportId: -1,
                        } }));
                    setReload(false);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    // 모바일 적용
    function M1650Pop(e, num) {
        CUTIL.jsopen_m_1650_Popup(e);
        setTabNum(num);
    }
    // 상세 정보 닫기
    function closePopup(id) {
        const infoPop = document.getElementById(id);
        var body = document.body;
        var dimm = body.querySelector(".dimm");
        if (!CUTIL.isnull(infoPop)) {
            infoPop.classList.add("m-hidden");
            infoPop.classList.remove("popup-layer");
            infoPop.classList.remove("js-layer");
            infoPop.classList.remove("popup-type1");
            infoPop.removeAttribute("style");
            if (!CUTIL.isnull(body))
                body.removeAttribute("style");
            if (!CUTIL.isnull(dimm))
                dimm.removeAttribute("style");
            return;
        }
    }
    function OutFocus(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/assessment/${check.assessmentId}`,
                appQuery: {
                    totalComment: e.target.value,
                    isTempSave: true,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setCheck(Object.assign(Object.assign({}, check), { totalComment: data.body.totalComment, assessmentInfo: {
                            isTempSave: true,
                            reportId: -1,
                        } }));
                    setReload(false);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : CONST.ERROR_MSG }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    // 프로그래스바
    let processRate = check.processRate * 100;
    let persent = processRate.toString().split(".")[0];
    return (_jsx(_Fragment, { children: _jsxs("article", Object.assign({ className: "box w100p" }, { children: [_jsx("div", Object.assign({ className: "box__header flex-column" }, { children: _jsxs("h2", { children: [_jsx("strong", { children: t("라벨.종합의견") }), _jsx("span", {})] }) })), _jsx("div", Object.assign({ className: "box__body" }, { children: _jsxs("section", Object.assign({ className: "flex-row m-m24" }, { children: [_jsxs("div", Object.assign({ className: "body-left" }, { children: [_jsxs("p", Object.assign({ className: "txt-info" }, { children: [t("라벨.점검이끝났습니다"), _jsx("br", {}), t("라벨.종합적인의견을작성하고결과를확인해주세요")] })), _jsxs("div", Object.assign({ className: "left-top" }, { children: [_jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("textarea", { placeholder: t("라벨.텍스트입력"), value: totalComment, onChange: (e) => setTotalComment(e.target.value), onKeyDown: (e) => CUTIL.beforeHandleComment(e, 1000), onKeyUp: (e) => CUTIL.afterHandleComment(e, 1000, setTotalComment), onBlur: (e) => OutFocus(e) }), _jsxs("p", Object.assign({ className: "txtnum" }, { children: [totalComment ? totalComment.length : "0", " / 1000"] }))] })), _jsxs("ul", Object.assign({ className: "lm-block clicktab-list" }, { children: [_jsx("li", Object.assign({ className: "js-open-m-1650", "data-pop": "m-1650", onClick: (e) => M1650Pop(e, 1) }, { children: t("라벨.사진첨부") })), _jsx("li", Object.assign({ className: "js-open-m-1650", "data-pop": "m-1650", onClick: (e) => M1650Pop(e, 2) }, { children: t("라벨.다음점검일설정") }))] }))] })), _jsxs("div", Object.assign({ className: "left-bottom" }, { children: [_jsx("div", Object.assign({ className: "progress-area" }, { children: _jsx("progress", { value: processRate, max: "100" }) })), _jsxs("div", Object.assign({ className: "btn-area" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray", onClick: (e) => totalCommentPreClick(e) }, { children: _jsx("span", { children: t("라벨.이전") }) })), _jsx("button", Object.assign({ type: "button", className: "js-open", "data-pop": "pop-confirm", onClick: (e) => (persent !== "100" ? totalCommentPop(e) : totalCommentClick(e)) }, { children: _jsx("span", { children: t("라벨.결과확인") }) }))] }))] }))] })), _jsxs("div", Object.assign({ className: "body-right m-popup m-hidden", id: "m-1650" }, { children: [_jsxs("div", Object.assign({ className: "box__header" }, { children: [_jsx("button", Object.assign({ className: "btn btn-prev js-close", onClick: (e) => closePopup("m-1650") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC774\uC804\uD398\uC774\uC9C0\uB85C" })) })), _jsx("p", Object.assign({ className: "box__title" }, { children: t("라벨.종합의견") }))] })), _jsx("ul", Object.assign({ className: "tab__line" }, { children: tabData.map((tab, idx) => (_jsx("li", Object.assign({ className: `click-tab ${tab.id == tabNum ? "on" : ""}`, "data-tab": "tab" + tab.id, onClick: (e) => TabClick(e, tab) }, { children: tab.name }), "tabs_" + idx.toString()))) })), _jsxs("div", Object.assign({ className: "right-bottom" }, { children: [_jsxs("div", Object.assign({ className: `tab-content ${tabNum == 1 ? "show" : ""}`, id: "tab-4" }, { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.사진파일업로드") })), _jsxs("ul", Object.assign({ className: "form__input mt-24" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.제목") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp", placeholder: t("라벨.사진제목입력"), value: potoName, onChange: (e) => setPotoName(e.target.value) }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.파일불러오기") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: "filebox" }, { children: [_jsx("input", { className: "upload-name", value: "", placeholder: t("라벨.사진첨부하세요"), readOnly: true }), _jsx("label", Object.assign({ htmlFor: "file" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uD30C\uC77C\uCC3E\uAE30" })) })), _jsx("input", { type: "file", accept: "image/*", id: "file", multiple: true, onChange: (e) => saveFileImage(e) })] })), _jsx("p", Object.assign({ className: "txt-info" }, { children: t("라벨.첨부500MB") })), file.map((img, idx) => (_jsx("ul", Object.assign({ className: "filelist" }, { children: _jsxs("li", { children: [_jsx("span", { children: img.name }), _jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => onClickAttachFileDelete(idx) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))] }) }), "img_" + idx.toString()))), _jsx("div", Object.assign({ className: "flex-inline right mt-24" }, { children: _jsx("button", Object.assign({ type: "button", className: "btn-basic", onClick: (e) => uploadFileImage(e) }, { children: _jsx("span", { children: t("라벨.업로드") }) })) }))] }))] })] })), _jsxs("div", Object.assign({ className: "imglist" }, { children: [_jsxs("p", Object.assign({ className: "tit" }, { children: [_jsx("span", { children: t("라벨.첨부사진내역") }), _jsxs("span", { children: [uploadFiles.length, "/10"] })] })), _jsx("ul", Object.assign({ className: "imgbox-area" }, { children: uploadFiles.map((img, idx) => (_jsxs("li", { children: [_jsxs("p", Object.assign({ className: "tit" }, { children: [_jsx("span", { children: img.groupName }), _jsxs("span", Object.assign({ className: "btn-area" }, { children: [_jsx("button", Object.assign({ type: "button", className: "btn btn-edit-g js-open", "data-pop": "pop-edit-image", onClick: (e) => ImageInfo(e, img) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC218\uC815" })) })), _jsx("button", Object.assign({ type: "button", className: "btn btn-delete-gr js-open", "data-pop": "pop-delete-image", onClick: (e) => ImageInfo(e, img) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))] }))] })), _jsx("div", Object.assign({ className: "img-area js-open", "data-pop": "pop-img", onClick: (e) => ImageInfo(e, img) }, { children: _jsx("img", { src: img.url, alt: img.name }) }))] }, "imgs_" + idx.toString()))) }))] }))] })), _jsxs("div", Object.assign({ className: `tab-content ${tabNum == 2 ? "show" : ""}`, id: "tab-2" }, { children: [_jsxs("p", Object.assign({ className: "txt-info flex-inline left-right ml-0 mb-24" }, { children: [_jsx("span", { children: t("라벨.다음점검일을미리설정해둘까요") }), _jsxs("span", { children: ["(", t("라벨.선택사항"), ")"] })] })), _jsxs("ul", Object.assign({ className: "form__input" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.점검유형") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp2", value: check.chekTypeInfo.checkTypeName, disabled: true }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.상세유형") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp2", value: check.chekSubTypeInfo.checkSubName, disabled: true }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.버전") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp2", value: check.chekVersionTypeInfo.versionNo, disabled: true }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.다음점검일") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx(DatePicker, { className: `calendar ${errorList.filter((err) => err.field === "dueDate").length > 0 ? " input-error" : ""}`, locale: langs === CONST.STR_LANG_ENG ? enUS : ko, todayButton: "today", dateFormat: "yyyy-MM-dd", selected: today, minDate: new Date(), onChange: (date) => setToday(date), 
                                                                                // onFocus={(e) => e.target.readOnly = true} // 모바일 키보드 제거
                                                                                withPortal: isMobile ? true : false, 
                                                                                // readOnly={(dateSel != 0) ? true : false}  // 직접 입력 이외 입력 제한
                                                                                placeholderText: t("라벨.점검예정일선택") }), _jsx("p", Object.assign({ className: "input-errortxt", style: {
                                                                                    display: errorList.filter((err) => err.field === "dueDate").length > 0 ? "block" : "none",
                                                                                } }, { children: errorList.filter((err) => err.field === "dueDate").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.자동점검주기") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "select", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: check.schdeulerId <= 0
                                                                                                ? t("라벨.클릭선택")
                                                                                                : check.period == 0
                                                                                                    ? t("라벨.없음")
                                                                                                    : check.period + t("라벨.일") })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: automaticCheckCycle.map((acc, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => automaticCheckCycleClick(acc) }, { children: acc.cycleNo }), "ACC_" + idx.toString()))) })] })) }))] })] })), _jsx("div", Object.assign({ className: "flex-inline right mt-40" }, { children: check.schdeulerId <= 0 ? (_jsx("button", Object.assign({ type: "button", className: "btn-basic", onClick: (e) => SchdeulerAdd(e) }, { children: _jsx("span", { children: t("라벨.저장") }) }))) : (_jsx("button", Object.assign({ type: "button", className: "btn-basic", onClick: (e) => SchdeulerEdit(e) }, { children: _jsx("span", { children: t("라벨.수정") }) }))) }))] }))] }))] }))] })) }))] })) }));
}
export default CheckLast;
export function useDebounceEffect(fn, waitTime, deps) {
    useEffect(() => {
        const t = setTimeout(() => {
            fn.apply(undefined, deps);
        }, waitTime);
        return () => {
            clearTimeout(t);
        };
    }, deps);
}
function ImageEditPop(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReload = useSetRecoilState(reLoadState);
    const [alert, setAlert] = useRecoilState(alertState);
    // props
    const { imageInfo, groupName, setGroupName } = props;
    function listEidt(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/image/checkvalue/groupName/${imageInfo.imageId}`,
                appQuery: {
                    groupName: groupName,
                },
                userToken: userInfo.loginInfo.token,
                watch: imageInfo,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    CUTIL.jsclose_Popup("pop-edit-image");
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-edit-image", type: CONST.TYPE_INNRE, divTag: t("라벨.수정되었습니다") }));
                    CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-edit-image");
                    setReload(false);
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("ul", Object.assign({ className: "form__input" }, { children: _jsx("li", { children: _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp2", value: groupName, onChange: (e) => setGroupName(e.target.value) }) })) }) })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-edit-image") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => listEidt(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
function ImageDeletePop(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReload = useSetRecoilState(reLoadState);
    const [alert, setAlert] = useRecoilState(alertState);
    // props
    const { imageInfo } = props;
    function listDel(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/image/${imageInfo.imageId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
                watch: imageInfo,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    CUTIL.jsclose_Popup("pop-delete-image");
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-delete-image", type: CONST.TYPE_INNRE, divTag: data.body }));
                    CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-delete-image");
                    setReload(false);
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: t("라벨.첨부된사진을삭제하시겠습니까") }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-image-delete") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => listDel(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
function ImagePop(props) {
    const t = useTrans();
    const { url } = props;
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("div", Object.assign({ className: "img-area" }, { children: _jsx("img", { src: url, alt: "\uBD84\uC804\uC18C \uC628\uB3C4 \uC0AC\uC9C4" }) })) })), _jsx("div", Object.assign({ className: "popup__footer" }, { children: _jsx("button", Object.assign({ type: "button", className: "js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-img") }, { children: _jsx("span", { children: t("라벨.확인") }) })) }))] }));
}
